import { HttpInterceptorFn, HttpResponse } from '@angular/common/http';
import { map } from 'rxjs/operators';

/**
 * Desenvuelve el envelope estándar de éxito una sola vez:
 *   { success, data, meta, message, timestamp, path, requestId }  ->  { data, meta, message }
 *
 * Solo actúa cuando el body es el envelope (objeto con `success === true`). Las respuestas que no
 * son JSON-envelope (blobs, CSV, text) pasan intactas. Ver docs/estandar-respuestas-api.md.
 *
 * Compatibilidad: para módulos aún no migrados el backend deja `data` = el objeto crudo previo
 * (p.ej. { data: rows, total }), por lo que `r.data.data` / `r.data.total` siguen resolviendo igual.
 */
export const apiResponseInterceptor: HttpInterceptorFn = (req, next) =>
  next(req).pipe(
    map((event) => {
      if (event instanceof HttpResponse) {
        const body = event.body as
          | { success?: unknown; data?: unknown; meta?: unknown; message?: unknown }
          | null;
        if (
          body &&
          typeof body === 'object' &&
          body.success === true &&
          'data' in body
        ) {
          return event.clone({
            body: {
              data: body.data ?? null,
              meta: body.meta ?? null,
              message: body.message ?? null,
            },
          });
        }
      }
      return event;
    }),
  );
